var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-container user-text"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"body-1 text-xs-left"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }